import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const deadlineOverride = (grant) => {
  if (grant?.deadline_type === "rolling") return "Rolling — no fixed deadline";
  if (grant?.deadline_type === "unconfirmed") return "Deadline: confirm with funder";
  return null;
};
